
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../../../core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartialsModule } from '../../partials/partials.module';
import { StockRoutingModule } from './stock/stock-routing.module';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatFormFieldModule, MatInputModule, MatTableModule, MatPaginatorModule, MatSortModule, MatProgressSpinnerModule, MatSelectModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatMenuModule, MatAutocompleteModule, MatRadioModule, MatNativeDateModule, MatProgressBarModule, MatDatepickerModule, MatCardModule, MatSnackBarModule, MatExpansionModule, MatTabsModule, MatTooltipModule, MatDialogModule } from '@angular/material';
import { LayoutUtilsService } from '../../../core/_base/crud';
import { ExcelService } from '../../../../test/service/excel.service';
import { AutocompleteComboComponent } from './common-components/autocomplete-combo/autocomplete-combo.component';
import { MetabaseDashboardComponent } from './common-components/metabase-dashboard/metabase-dashboard.component';
import { ChecklistTreeComponent } from './common-components/checklist-tree/checklist-tree.component';
import { ProductComponent } from './product/product.component';
import { PhotoDirective } from './shared/directives/photo.directive';
import { OrderModule } from './order/order.module';
import { AppSessionService } from '@shared/session/app-session.service';
import { UserComponent } from './user/user.component';
import { ProfileComponent } from './user/profile/profile.component';
import { ChangeUserCustomerModule } from './usercustomer/change-usercustomer-modal/change-usercustomer-modal.module';
import { CustomLocalizationService } from './utility/customLocalization.service';
import { ProductPhotoComponent } from './common-components/product-photo/product-photo.component';

import { MytestpageComponent } from './mytestpage/mytestpage.component';
import { PosmDemandModule } from './posm-demand/posm-demand.module';



@NgModule({
	declarations: [MytestpageComponent],
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    PartialsModule,

  
    ReactiveFormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,

    MatMenuModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
	  MatDialogModule,
	  ChangeUserCustomerModule,
    PosmDemandModule
  ],  
  exports: [
   
  ],
  providers: [
    {
			provide: MAT_DIALOG_DEFAULT_OPTIONS,
			useValue: {
				hasBackdrop: true,
				panelClass: 'kt-mat-dialog-container__wrapper',
				height: 'auto',
				width: '900px'
			}
		},
    LayoutUtilsService,
	  ExcelService,
	  
  ],
})
export class TranspopModule { }
